import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../model/user.model';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { SharedVals } from '../../../shared/SharedVals';
import { OktaAuthService } from '@okta/okta-angular';
import { UserDataService } from '../../services/user/userData.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


export class HomeComponent implements OnInit {
  isLoginSuccess = null;
  userForm;
  notValid: boolean = false;
  reEmail = new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
  email: string = '';
  user = new User();
  message: string = '';
  public agentId: any;


  constructor(
   
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    public userDataService: UserDataService,
    public sharedVals: SharedVals,
    public oktaAuth: OktaAuthService) {
    
  }
  async ngOnInit() {
    await this.userDataService.getLoggerData();
    this.userDataService.userData$.subscribe((data: any)=>{
      if(data.isAuthenticated){
        const role = data.userRole;
        const roleVal = data.userRoleVal;
        console.log('role'+ role);
        console.log('roleval' + roleVal);
        localStorage.setItem("username", data.userName);
        localStorage.setItem('Lastname', data.lastName);
        localStorage.setItem("loginID", data.loginId);
        localStorage.setItem('Token', data.accessToken);
        localStorage.setItem('X-correlation-id', '12345');//to-do-check if this really required
        localStorage.setItem('Role', role);
        localStorage.setItem('RoleVal', `${roleVal}`);
        localStorage.setItem('isNavigate', 'true');
        localStorage.setItem('userId', data.userName);//
        localStorage.setItem('AgentId','0');//We don't have to get the agent id form user as this would only be used for vendor role which is removed. Master vendor id is 0 for all other roles.
        this.sharedVals.setRoleVal(roleVal);
        this.sharedVals.setRole(role);
        this.sharedVals.setLoginId(data.loginId);
        this.agentId = localStorage.getItem("AgentId");
        if (roleVal === 1 ) {//&& res.IsActive === 'Y' // removed from all if as we dont have this in okta res
          this.router.navigate(['/maindashboard']);
        } else if (roleVal === 8 ) {
          this.router.navigate(['/agentsearchlist']);
        } else if (roleVal === 4 ) {
          this.router.navigate(['par/dashboard/Dashboard']);
        } else if (roleVal === 16 ) {
          this.router.navigate(['par/dashboard/Dashboard']);
        } else if (roleVal === 128 ) {
          this.router.navigate(['par/managecomplaints']);
        }else  {
          this.router.navigate(['/logout']);
        }  
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts